<template>
	<div class="top">
		<div class="justify-content-center row">
			<div class="col-xl-4">
				<card class="card" title="Login">
					<template slot="image">
						<img height="50%" src="../../assets/img/caslogo.png">
					</template>
					<form @submit.prevent="login">
						<div class="row">
							<div class="col-12">
								<fg-input type="text"
									label="Username"
									placeholder="Username"
									:class="{'has-error':$v.user.username.$error}"
									v-model="$v.user.username.$model">
								</fg-input>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<fg-input type="password"
									label="Password"
									placeholder="Password"
									:class="{'has-error':$v.user.password.$error}"
									v-model="$v.user.password.$model">
								</fg-input>
							</div>
						</div>
						<div class="row">
							<div class="col-12 text-right">
								<button class='btn btn-round btn-success' type="submit">
									<i v-if="loading" class="fa fa-spinner fa-spin"></i>
									Login
								</button>
							</div>
						</div>
					</form>
				</card>
			</div>
		</div>
	</div>
</template>

<script>

import {required} from 'vuelidate/lib/validators';
import {mapGetters} from 'vuex'

export default {
	data(){
		return {
			user:{
				username : null,
				password : null
			},
			loading:false
		}
	},
	computed:{
		...mapGetters([
			'isLoggedIn'
		])
	},
	validations:{
		user:{
			username:{required},
			password:{required}
		}
	},
	methods: {
		async login() {
			this.$v.user.$touch();
			if(!this.$v.user.$invalid){
				try{
					this.loading = true;
					await this.$store.dispatch('login',this.user);
					//debugger;
					this.loading = false;
					this.$router.push('/dashboard')
				}
				catch(error){
					this.loading = false;
					this.$toast.error({
						message:'Username or password wrong',
						icon:'ti-face-sad',
						position:'topCenter'
					})
				}
			}
		}
	},
	beforeMount(){
		if(this.isLoggedIn){
			this.$router.push('/dashboard');
		}
	}
}
</script>

<style scoped>
.top{
	margin-top: 1%;
}
</style>